import { render, staticRenderFns } from "./DailyInvestment.vue?vue&type=template&id=aa93d43c&scoped=true"
import script from "./DailyInvestment.vue?vue&type=script&lang=js"
export * from "./DailyInvestment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa93d43c",
  null
  
)

export default component.exports